export default __webpack_public_path__ + "static/media/food-valley.be51f86d.PNG";